import React from 'react';
import { motion } from 'framer-motion';
import { Circle } from 'lucide-react';
export interface Option {
  id: string;
  text: string;
}
interface QuizQuestionProps {
  question: string;
  options: Option[];
  onAnswer: (optionId: string) => void;
  imageUrl?: string;
  imageAlt?: string;
  compact?: boolean;
  references?: string;
}
export function QuizQuestion({
  question,
  options,
  onAnswer,
  imageUrl,
  imageAlt,
  compact = false,
  references
}: QuizQuestionProps) {
  return <div className="w-full max-w-3xl mx-auto" data-id="element-99">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} className="bg-gray-50 rounded-xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-100">
        <div className={`flex ${imageUrl ? 'flex-row' : ''}`} data-id="element-101">
          {imageUrl && <div className="w-2/5 shrink-0 overflow-hidden" data-id="element-102">
              <img src={imageUrl} alt={imageAlt || 'Quiz illustration'} className="w-full h-full object-cover" data-id="element-103" />
            </div>}

          <div className={`${compact ? 'p-3 md:p-4' : 'p-4 md:p-5'} flex-1 ${imageUrl ? '' : 'w-full'}`} data-id="element-104">
            <h2 className={`${compact ? 'text-sm md:text-base' : 'text-base md:text-lg'} font-bold text-brand-primary ${compact ? 'mb-2' : 'mb-3'} leading-tight`} data-id="element-105">
              {question}
            </h2>

            <div className={compact ? 'space-y-1' : 'space-y-1.5'} data-id="element-106">
              {options.map((option, index) => <motion.button key={option.id} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.1
            }} onClick={() => onAnswer(option.id)} className={`w-full text-left ${compact ? 'px-2.5 py-2' : 'p-2.5'} rounded-lg border-2 border-gray-200 bg-white text-text-subtle hover:bg-gray-50 hover:border-brand-primary/30 transition-all duration-200 flex items-start gap-2 group relative`} data-id="element-107">
                  <div className="mt-0.5 shrink-0 transition-colors text-gray-400 group-hover:text-button-hover" data-id="element-108">
                    <Circle className={compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} data-id="element-109" />
                  </div>
                  <span className={`font-medium ${compact ? 'text-[12px] leading-snug' : 'text-sm'}`} data-id="element-110">
                    {option.text}
                  </span>
                </motion.button>)}
            </div>
          </div>
        </div>

        {references && <div className="px-4 pb-2 pt-1 border-t border-gray-100 mx-3 mb-1 max-h-16 overflow-y-auto" data-id="element-111">
            <p className="text-[8px] leading-relaxed text-gray-400 font-normal" style={{
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif'
        }} data-id="element-112">
              <span className="font-semibold text-gray-500 text-[8px]" data-id="element-113">
                References:{' '}
              </span>
              {references.split('\n').map((ref, i) => <span key={i} data-id="element-114">
                  {ref}
                  {i < references.split('\n').length - 1 ? ' · ' : ''}
                </span>)}
            </p>
          </div>}
      </motion.div>
    </div>;
}